export const BASE_PATH = "/furniture"
export const API_PATH = "/furniture/api"